<template>
  <!--聊天窗口 -->
  <div class="chat-window" v-if="visible" 
       :style="{ left: position.x + 'px', top: position.y + 'px' }">
    <!-- 关闭按钮 -->
    <div class="close-btn" @click="handleClose">
      <i class="el-icon-close"></i>
    </div>
    <!-- 左边内容 -->
    <div class="left-content">
      <!--  顶部内容 -->
  
      <h4 style="padding: 5px;">群聊</h4>
      <!-- 表格区域 可以上下滚动 -->
      <div class="user-list">
        <div class="user-item" v-for="item in chatGroupList" :key="item.id" @click="selectGroup(item)">
          <div class="css-avatar group-avatar">群</div>
          <div style="font-size: 14px;">
            <div>{{ item.name }}</div>
            <div v-if="item.memberCount" style="font-size: 12px; color: #888;">{{ item.memberCount }}人</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边内容 -->
    <div class="right-content">
      <!-- 顶部内容 -->
      <div class="right-top-content" @mousedown="startDrag">
        <div style="display: flex; align-items: center; gap: 12px;">
          <div v-if="selectedGroup" class="css-avatar group-avatar" style="cursor: pointer;" @click.stop="openMemberDialog">群</div>
          <h4 style="margin: 0; color: #999;" v-if="!selectedGroup">请选择群聊</h4>
          <h4 style="margin: 0;" v-else>{{ selectedGroup.name }}</h4>
        </div>
      </div>
      <!-- 聊天区 -->
      <div class="right-chat-list" ref="chatList">
        <div v-for="message in chatMessages" :key="message.id" class="chat-message"
          :class="message.type === 'own' ? 'own-message' : 'other-message'">
          <!-- 左侧消息：头像在左，内容在右 -->
          <template v-if="message.type === 'other'">
            <div class="css-avatar" :class="getAvatarClass(message)">{{ getAvatarText(message) }}</div>
            <div class="message-content">
              <div class="message-bubble other-bubble">
                {{ message.content }}
              </div>
            </div>
          </template>
          <!-- 右侧消息：内容在左，头像在右 -->
          <template v-else>
            <div class="message-content">
              <div class="message-bubble own-bubble">
                {{ message.content }}
              </div>
            </div>
            <div class="css-avatar" :class="getAvatarClass(message)">{{ getAvatarText(message) }}</div>
          </template>
        </div>
      </div>
      <!-- 底部输入文字区 -->
      <div class="right-bottom-input">
        <!-- 顶部图片区域 -->
        <div class="input-top-icons">
          <i class="el-icon-chat-dot-round"></i>
        </div>
        <!-- 输入区域 -->
        <div class="input-area">
          <textarea v-model="inputMessage" placeholder="请输入消息内容..." class="message-input"
            @keydown.enter.prevent="sendMessage" @input="checkInputStatus"></textarea>
          <!-- 发送区域 -->
          <button class="send-button" :class="{ 'disabled': !canSend }" :disabled="!canSend" @click="sendMessage">
            发送
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      title="群成员"
      :visible.sync="memberDialogVisible"
      width="320px"
      append-to-body>
      <div v-if="selectedGroup.memberList && selectedGroup.memberList.length" style="max-height: 300px; overflow-y: auto; text-align: left;">
        <div v-for="(member, index) in selectedGroup.memberList" :key="index" style="padding: 4px 0;">
          {{ index + 1 }}、{{ member }}
        </div>
      </div>
      <div v-else style="text-align: center; padding: 12px 0;">暂无成员数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="memberDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ChatWindow',
  props: {
    // 是否显示聊天窗口
    visible: {
      type: Boolean,
      default: false
    },
    // 聊天窗口位置
    position: {
      type: Object,
      default: () => ({ x: 100, y: 100 })
    },
    // 当前用户信息
    currentUser: {
      type: Object,
      default: () => ({
        name: '',
        avatar: ''
      })
    },
    // 聊天群组列表
    chatGroupList: {
      type: Array,
      default: () => [
      ]
    },
    // 聊天消息列表
    chatMessages: {
      type: Array,
      default: () => [
      ]
    },
    // 默认选中的群组
    defaultGroup: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 聊天相关数据
      inputMessage: '', // 输入的消息内容
      canSend: false, // 是否可以发送消息
      
      // 拖拽相关数据
      isDragging: false, // 是否正在拖拽
      dragOffset: { x: 0, y: 0 }, // 拖拽偏移量
      
      // 选中的群组
      selectedGroup: {},
      memberDialogVisible: false
    }
  },
  methods: {
    openMemberDialog(){
      this.memberDialogVisible = true;

    },
    // 关闭聊天窗口
    handleClose() {
      this.$emit('close')
    },

    // 选择群组
    selectGroup(group) {
      this.selectedGroup = group
      this.$emit('group-selected', group)
    },

    // 检查输入状态，控制发送按钮
    checkInputStatus() {
      this.canSend = this.inputMessage.trim().length > 0
    },

    // 发送消息
    sendMessage() {
      if (!this.canSend) return

      const message = this.inputMessage.trim()
      if (!message) return

      // 添加新消息到聊天列表
      const newMessage = {
        id: Date.now(),
        type: 'own',
        content: message,
        avatar: this.currentUser.avatar
      }
      this.$emit('send-message', newMessage)
      // 清空输入框
      this.inputMessage = ''
      this.canSend = false
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },

    // 滚动到底部
    scrollToBottom() {
      const chatList = this.$refs.chatList
      if (chatList) {
        setTimeout(() => {
          chatList.scrollTop = chatList.scrollHeight
        }, 100)
      }
    },

    // 开始拖拽
    startDrag(event) {
      // 只在顶部内容区域开始拖拽
      if (!event.target.closest('.left-top-content') && !event.target.closest('.right-top-content')) return
      
      this.isDragging = true
      const rect = this.$el.getBoundingClientRect()
      this.dragOffset.x = event.clientX - rect.left
      this.dragOffset.y = event.clientY - rect.top
      
      // 添加全局事件监听
      document.addEventListener('mousemove', this.handleDrag)
      document.addEventListener('mouseup', this.stopDrag)
      
      // 防止默认行为
      event.preventDefault()
    },

    // 处理拖拽
    handleDrag(event) {
      if (!this.isDragging) return
      
      const newX = event.clientX - this.dragOffset.x
      const newY = event.clientY - this.dragOffset.y
      
      // 限制拖拽范围，防止窗口拖出屏幕
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const chatWindowWidth = 800 // 聊天窗口宽度
      const chatWindowHeight = 600 // 聊天窗口高度
      
      const newPosition = {
        x: Math.max(0, Math.min(newX, windowWidth - chatWindowWidth)),
        y: Math.max(0, Math.min(newY, windowHeight - chatWindowHeight))
      }
      
      // 通过事件向父组件更新位置
      this.$emit('position-change', newPosition)
    },

    // 停止拖拽
    stopDrag() {
      this.isDragging = false
      
      // 移除全局事件监听
      document.removeEventListener('mousemove', this.handleDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },

    // 获取头像文字
    getAvatarText(message) {
      // 根据 senderType 判断：senderType===0 是专家，senderType===1 是投标人
      if (message.senderType !== undefined) {
        return message.senderType === 0 ? '专' : '投'
      }
      return '专'
    },

    // 获取头像样式类
    getAvatarClass(message) {
      if (message.senderType !== undefined) {
        return message.senderType === 0 ? 'expert-avatar' : 'bidder-avatar'
      }
      return message.type === 'own' ? 'expert-avatar' : 'bidder-avatar'
    }
  },
  watch: {
    // 监听消息变化，自动滚动到底部
    chatMessages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      },
      deep: true
    },
    // 根据父组件传入的默认群组初始化/更新选中群组
    defaultGroup: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.selectedGroup = newVal
        }
      }
    }
  },
  beforeDestroy() {
    //销毁监听
    document.removeEventListener('mousemove', this.handleDrag)
    document.removeEventListener('mouseup', this.stopDrag)
  }
}
</script>

<style scoped lang="less">
// 聊天区域
.chat-window {
  position: fixed;
  width: 50vw;
  height: 50vh;
  display: flex;
  z-index: 2000;
  background-color: #fbfafa;
  border: 2px solid #e0e0e0;
  overflow: hidden;
  user-select: none; // 防止拖拽时选中文本
  cursor: default;

  .head-img {
    width: 45px;
    height: 45px;
    border-radius: 3px;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;

    i {
      font-size: 16px;
      color: #666;
    }
  }

  .left-content {
    width: 30%;
    border-right: 1px solid #e9ecef;
    text-align: start;
    display: flex;
    flex-direction: column;
    height: 100%;

    .left-top-content {
      height: 80px;
      background-color: white;
      display: flex;
      cursor: move;
      align-items: center;
      padding: 10px;
      flex-shrink: 0;

      .top-content-left-title {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }

    h4 {
      margin: 0;
      padding: 10px;
      background-color: #f5f5f5;
      flex-shrink: 0;
    }

    .user-list {
      flex: 1;
      overflow-y: auto;
      background-color: white;

      .user-item {
        padding: 10px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid #e0e0e0;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }

  .right-content {
    width: 70%;
    display: flex;
    flex-direction: column;
    height: 100%;

    .right-top-content {
      height: 80px;
      display: flex;
      align-items: center;
      cursor: move;
      padding: 10px;
      border-bottom: 1px solid #e0e0e0;
      flex-shrink: 0;
      background-color: white;
    }

    .right-chat-list {
      flex: 1;
      overflow-y: auto;
      background-color: white;
      padding: 10px;

      .chat-message {
        display: flex;
        margin-bottom: 15px;
        align-items: flex-end;

        .message-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .message-content {
          max-width: 60%;
          margin: 0 10px;

          .message-bubble {
            padding: 10px 15px;
            border-radius: 18px;
            font-size: 14px;
            line-height: 1.4;
            word-wrap: break-word;
            position: relative;
          }
        }

        &.own-message {
          justify-content: flex-end;

          .message-content {
            order: 1;
          }

          .css-avatar {
            order: 2;
          }

          .message-avatar {
            order: 2;
          }

          .own-bubble {
            background-color: #4CAF50;
            color: white;
            border-bottom-right-radius: 4px;
          }
        }

        &.other-message {
          justify-content: flex-start;

          .message-avatar {
            order: 1;
          }

          .message-content {
            order: 2;
          }

          .other-bubble {
            background-color: #f0f0f0;
            color: #333;
            border-bottom-left-radius: 4px;
          }
        }
      }
    }

    .right-bottom-input {
      height: 100px;
      background-color: white;
      border-top: 1px solid #e0e0e0;
      flex-shrink: 0;
      padding: 10px;
      display: flex;
      flex-direction: column;

      .input-top-icons {
        display: flex;
        align-items: center;
      }

      .input-area {
        flex: 1;
        display: flex;
        align-items: flex-end;
        position: relative;

        .message-input {
          flex: 1;
          border: 0px solid #ddd;
          font-size: 14px;
          resize: none;
          outline: none;
          max-height: 60px;
          min-height: 36px;
          line-height: 1.4;
          font-family: inherit;
        }

        .send-button {
          position: absolute;
          right: 5px;
          bottom: 5px;
          background-color: #4CAF50;
          color: white;
          border: none;
          border-radius: 15px;
          padding: 6px 12px;
          font-size: 12px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover:not(.disabled) {
            background-color: #45a049;
          }

          &.disabled {
            background-color: #ccc;
            cursor: not-allowed;
            color: #999;
          }
        }
      }
    }
  }
}

// CSS 绘制的圆形头像
.css-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: white;
  flex-shrink: 0;
}

// 群头像 - 蓝色
.group-avatar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

// 专家头像 - 绿色
.expert-avatar {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
}

// 投标人头像 - 橙色
.bidder-avatar {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
}

// 聊天消息中的头像尺寸
.chat-message .css-avatar {
  width: 40px;
  height: 40px;
  font-size: 16px;
}
</style>
